import { startCase } from 'lodash';
export class CustomerSegmentModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    /**
     * Humanized Customer Segment Name
     * Replace underscore with whitespace
     * @author Jimson Lomio <jimson@gorated.ph>
     * @since Version 0.1.6
     *
     * @return string
     */
    get humanizedName() {
        return startCase(this.name);
    }
}
